import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["slideFooter"],
  _excluded2 = ["captions", "render", "toolbar"];
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { cssClass, useLightboxProps, makeUseContext, useController, clsx, cssVar, translateLabel, createIcon, createIconDisabled, IconButton, addToolbarButton, createModule } from '../../index.js';
import { PLUGIN_CAPTIONS } from '../../types.js';
var cssPrefix = function cssPrefix(className) {
  return cssClass("slide_".concat(className));
};
var defaultCaptionsProps = {
  descriptionTextAlign: "start",
  descriptionMaxLines: 3,
  showToggle: false,
  hidden: false
};
var resolveCaptionsProps = function resolveCaptionsProps(captions) {
  return _objectSpread(_objectSpread({}, defaultCaptionsProps), captions);
};
function useCaptionsProps() {
  var _useLightboxProps = useLightboxProps(),
    captions = _useLightboxProps.captions;
  return resolveCaptionsProps(captions);
}
var CaptionsContext = React.createContext(null);
var useCaptions = makeUseContext("useCaptions", "CaptionsContext", CaptionsContext);
function CaptionsContextProvider(_ref) {
  var captions = _ref.captions,
    children = _ref.children;
  var _resolveCaptionsProps = resolveCaptionsProps(captions),
    ref = _resolveCaptionsProps.ref,
    hidden = _resolveCaptionsProps.hidden;
  var _React$useState = React.useState(!hidden),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    visible = _React$useState2[0],
    setVisible = _React$useState2[1];
  var context = React.useMemo(function () {
    return {
      visible: visible,
      show: function show() {
        return setVisible(true);
      },
      hide: function hide() {
        return setVisible(false);
      }
    };
  }, [visible]);
  React.useImperativeHandle(ref, function () {
    return context;
  }, [context]);
  return React.createElement(CaptionsContext.Provider, {
    value: context
  }, children);
}
function Title(_ref2) {
  var title = _ref2.title;
  var _useController = useController(),
    toolbarWidth = _useController.toolbarWidth;
  var _useLightboxProps2 = useLightboxProps(),
    styles = _useLightboxProps2.styles;
  var _useCaptions = useCaptions(),
    visible = _useCaptions.visible;
  if (!visible) return null;
  return React.createElement("div", {
    role: "heading",
    "aria-level": 2,
    style: styles.captionsTitleContainer,
    className: clsx(cssPrefix("captions_container"), cssPrefix("title_container"))
  }, React.createElement("div", {
    className: cssPrefix("title"),
    style: _objectSpread(_objectSpread({}, toolbarWidth ? _defineProperty({}, cssVar("toolbar_width"), "".concat(toolbarWidth, "px")) : null), styles.captionsTitle)
  }, title));
}
function Description(_ref4) {
  var _ref5;
  var description = _ref4.description;
  var _useCaptionsProps = useCaptionsProps(),
    descriptionTextAlign = _useCaptionsProps.descriptionTextAlign,
    descriptionMaxLines = _useCaptionsProps.descriptionMaxLines;
  var _useLightboxProps3 = useLightboxProps(),
    styles = _useLightboxProps3.styles,
    labels = _useLightboxProps3.labels;
  var _useCaptions2 = useCaptions(),
    visible = _useCaptions2.visible;
  if (!visible) return null;
  return React.createElement("div", {
    style: styles.captionsDescriptionContainer,
    className: clsx(cssPrefix("captions_container"), cssPrefix("description_container"))
  }, React.createElement("div", {
    className: cssPrefix("description"),
    style: _objectSpread(_objectSpread({}, descriptionTextAlign !== defaultCaptionsProps.descriptionTextAlign || descriptionMaxLines !== defaultCaptionsProps.descriptionMaxLines ? (_ref5 = {}, _defineProperty(_ref5, cssVar("slide_description_text_align"), descriptionTextAlign), _defineProperty(_ref5, cssVar("slide_description_max_lines"), descriptionMaxLines), _ref5) : null), styles.captionsDescription),
    role: "paragraph",
    "aria-roledescription": translateLabel(labels, "Caption")
  }, typeof description === "string" ? description.split("\n").flatMap(function (line, index) {
    return [].concat(_toConsumableArray(index > 0 ? [React.createElement("br", {
      key: index
    })] : []), [line]);
  }) : description));
}
var captionsIcon = function captionsIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    strokeWidth: 2,
    stroke: "currentColor",
    strokeLinejoin: "round",
    fill: "none",
    d: "M3 5l18 0l0 14l-18 0l0-14z"
  }), React.createElement("path", {
    d: "M7 15h3c.55 0 1-.45 1-1v-1H9.5v.5h-2v-3h2v.5H11v-1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm7 0h3c.55 0 1-.45 1-1v-1h-1.5v.5h-2v-3h2v.5H18v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1z"
  }));
};
var CaptionsVisible = createIcon("CaptionsVisible", captionsIcon());
var CaptionsHidden = createIconDisabled("CaptionsVisible", captionsIcon());
function CaptionsButton() {
  var _useCaptions3 = useCaptions(),
    visible = _useCaptions3.visible,
    show = _useCaptions3.show,
    hide = _useCaptions3.hide;
  var _useLightboxProps4 = useLightboxProps(),
    render = _useLightboxProps4.render;
  if (render.buttonCaptions) {
    return React.createElement(React.Fragment, null, render.buttonCaptions({
      visible: visible,
      show: show,
      hide: hide
    }));
  }
  return React.createElement(IconButton, {
    label: visible ? "Hide captions" : "Show captions",
    icon: visible ? CaptionsVisible : CaptionsHidden,
    renderIcon: visible ? render.iconCaptionsVisible : render.iconCaptionsHidden,
    onClick: visible ? hide : show
  });
}
function Captions(_ref6) {
  var augment = _ref6.augment,
    addModule = _ref6.addModule;
  augment(function (_ref7) {
    var captionsProps = _ref7.captions,
      _ref7$render = _ref7.render,
      renderFooter = _ref7$render.slideFooter,
      restRender = _objectWithoutProperties(_ref7$render, _excluded),
      toolbar = _ref7.toolbar,
      restProps = _objectWithoutProperties(_ref7, _excluded2);
    var captions = resolveCaptionsProps(captionsProps);
    return _objectSpread({
      render: _objectSpread({
        slideFooter: function slideFooter(_ref8) {
          var slide = _ref8.slide;
          return React.createElement(React.Fragment, null, renderFooter === null || renderFooter === void 0 ? void 0 : renderFooter({
            slide: slide
          }), slide.title && React.createElement(Title, {
            title: slide.title
          }), slide.description && React.createElement(Description, {
            description: slide.description
          }));
        }
      }, restRender),
      toolbar: addToolbarButton(toolbar, PLUGIN_CAPTIONS, captions.showToggle ? React.createElement(CaptionsButton, null) : null),
      captions: captions
    }, restProps);
  });
  addModule(createModule(PLUGIN_CAPTIONS, CaptionsContextProvider));
}
export { Captions as default };